export const APP_VERSION = process.env.APP_VERSION;
export const APP_VERSION_DATETIME = process.env.APP_VERSION_DATETIME;

export const exposeAppVersion = () => {
  window.APP_VERSION = APP_VERSION;
  window.APP_VERSION_DATETIME = APP_VERSION_DATETIME;
};
